import { render, staticRenderFns } from "./NewStudies.vue?vue&type=template&id=0aedc01a&scoped=true&"
import script from "./NewStudies.vue?vue&type=script&lang=js&"
export * from "./NewStudies.vue?vue&type=script&lang=js&"
import style0 from "./NewStudies.vue?vue&type=style&index=0&id=0aedc01a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aedc01a",
  null
  
)

export default component.exports